module.exports = __webpack_public_path__ + "img/dab_koral.79b1edf8.jpg";